import { resolveRole } from './accessContract'

export function loginDestination(role: unknown): string {
  const canonical = resolveRole(role).canonicalRole
  if (canonical === 'cml_operations') return '/platform/monitoring'
  if (canonical?.startsWith('cml_')) return '/platform'
  if (canonical === 'individual_client') return '/my-tax'
  if (canonical === 'business_owner_client' || canonical === 'authorized_client') {
    return '/my-business'
  }
  return '/dashboard'
}
